export default __webpack_public_path__ + "static/media/lockscreen.308acb00.png";